(function () {
	'use strict';

	angular.module('adf')
		.directive('adfDashboard', ['$window', '$log', '$http', '$q', '$uibModal', '$interval',
			'$experiments', 'dashboard', 'adfTemplatePath',
			'focus', 'chartService', '$translate', 'userConfigUtilsService', 'URLS',
			function ($window, $log, $http, $q, $uibModal, $interval, $experiments,	dashboard,
				adfTemplatePath, focus, chartService, $translate, userConfigUtilsService, URLS) {

				function setMaxWidthOfFilterDiv() {
					var hasExtraText = jQuery('.extraText') && jQuery('.extraText').length;
					var width = jQuery('.dashboard').width() - jQuery('.filters.dropdown').width() - 100;
					var width2 = jQuery('.row').width() - 40;
					var totalFilters = jQuery('.filtersContainer .currentFilters').length;
					var minWidthOfFilters = totalFilters * 54 + jQuery('.filters.dropdown').width();
					if (width2 < minWidthOfFilters) {
						jQuery('.filtersContainer .row').css('height', 88);
						jQuery('.filtersContainer').css('height', 88);
						jQuery('.filterRowWidthAdjuster').css('width', width);
					} else {
						if (!hasExtraText) {
							jQuery('.filtersContainer .row').css('height', 44);
							jQuery('.filtersContainer').css('height', 44);
						} else {
							jQuery('.filtersContainer').css('height', 0);
						}
						jQuery('.filterRowWidthAdjuster').css('width', '100%');
					}
					jQuery('.filtersContainer.tableAttached').css('height', 56);
					jQuery('.filtersContainer.tableAttached .row').css('height', 52);
					var maxWidth = width / totalFilters - 16 > 400 ? 400 : width / totalFilters - 16;
					jQuery('.filtersContainer .currentFilters').css('maxWidth', maxWidth);
					jQuery('.filtersContainer .currentFilters .filterEdit').css('maxWidth', maxWidth);
				}

				function checkForNewSboReport() {
					return _.toArray(globalConfig.user.authFacts).filter(function (site) {
						return site.customerNdx === globalConfig.customer.id
							&& site.settings
							&& site.settings['ShortageByOrderReport'] === 'Custom Tabular Report (New)';
					}).length;
				}

				function getWidgets() {
					var widgets = dashboard.widgets;
					var categories = {};
					var widgetsToHide = [
						'posToCancelNext90Days',
						'openPOsForExcessMaterial',
						'openPOsForObsoleteMaterial',
						'openPOsForExcessOverLeadTimeMultiple',
						'posToActionNext12MonthsHistory'
					];
					for (var key in widgets) {
						if ((key === 'shortagesByOrderLines' && !checkForNewSboReport())
							|| !widgets[key].isActive
							|| (globalConfig.customer.hidePosToAction && widgetsToHide.indexOf(key) !== -1)
							|| (!$experiments.isEnabled('workbench-kpi') && key.startsWith('workbench'))
							|| (widgets[key].experiment && !$experiments.isEnabled(widgets[key].experiment))
						) {
							continue;
						}
						widgets[key].categories.forEach(function(cat) {
							if (!categories[cat]) {
								categories[cat] = [];
							}
							categories[cat].push(widgets[key]);
							widgets[key].type = key;
						});
					}
					// Wanted to order this with enumerating, but it looks like it doesn't have an order
					var widgets = [
						{name: 'All', widgets: widgetSort(categories['All'])},
						{name: 'Inventory', widgets: widgetSort(categories['Inventory'])},
						{name: 'Lean Projects', widgets: widgetSort(categories['Lean Projects'])},
						{name: 'Supplier Performance', widgets: widgetSort(categories['Supplier Performance'])},
						{name: 'Shortages', widgets: widgetSort(categories['Shortages'])},
						{name: 'Task Management', widgets: widgetSort(categories['Task Management'])},
						{name: 'Metrics', widgets: widgetSort(categories['Metrics'])}
					];
					if ($experiments.isEnabled('workbench-kpi')) {
						widgets.push({name: 'Workbench', widgets: widgetSort(categories['Workbench'])});
					}

					if ($experiments.isLeanOnly()) {
						widgets = filterLeanOnlyWidgets(widgets);
					}

					return widgets;
				}

				function widgetSort(widgets) {
					return widgets.sort(function(a,b) {
						return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1;
					});
				}

				function filterLeanOnlyWidgets(widgets) {
					widgets = widgets.filter(function(f) {				
						return f.name === 'Lean Projects'  || f.name === 'Metrics' || f.name === 'All';
					});
					widgets = widgets.map(function(f) {									
						if (f.name === 'All') {
							f.widgets = f.widgets.filter(function(w) {
								return w.name === 'Lean Project Cumulative Savings' || w.name === 'Lean Project Summary' ||
									w.name === 'Lean Projects by Area, Site, or Business Unit' || w.name === 'Project Progress Summary by Due Date' ||
									w.name === 'Task Progress Summary by Due Date' || w.name === 'Metrics' || w.name === 'Custom Text';
							});
							return f;
						} else {
							return f;
						}
					});
					return widgets;
				}

				function setUpdateConfigurations($timeout) {
					$timeout(function () {
						// dashboard_global_functions
						syncColHeights();
					}, 0);
				}

				var w = angular.element($window);
				w.bind('resize', function () {
					setMaxWidthOfFilterDiv();
				});


				return {
					replace: true,
					restrict: 'EA',
					transclude: false,
					scope: {
						structure: '@',
						name: '@',
						collapsible: '@',
						adfModel: '=',
						columnDefinitions: '=',
						widgetIndex: '='
					},
					controller: function ($scope, $location, $state, $timeout, $rootScope,
						$experiments, slideshowControls, dashboard,
						performanceDashboardService, dashboardService,
						performanceDashboardDescription, navigationService,
						WEEKLY_LOG_ITEM_FIELDS, weeklyLogItemService, leanFilterService,
						tableFilterFunctionsService, dashboardFilterInitializationService,
						storeService, dashboardCreationService) {
						// sortable options for drag and drop
						var model = {};
						var checkedForSlideshow = false;
						var needPerformanceDashboardReload = false;
						$scope.sortableOptions = {
							connectWith: '.column',
							handle: '.panel-heading',
							cursor: 'move',
							tolerance: 'pointer',
							placeholder: 'placeholder',
							forcePlaceholderSize: true,
							opacity: 0.4,
							stop: function (ev, ui) {
								if (ui.item.sortable.source && ui.item.sortable.droptarget) {
									storeService.dispatch({
										type: storeService.actions.CONFIG_WIDGET_MOVE_ONE,
										payload: {
											sourceColumn: 'column' + ui.item.sortable.source[0].getAttribute('data-column-index'),
											destinationColumn: 'column' + ui.item.sortable.droptarget[0].getAttribute('data-column-index'),
											sourcePosition: ui.item.sortable.index,
											destinationPosition: ui.item.sortable.dropindex
										},
										meta: {
											reportName: undefined,
											reportSettingsId: globalReportName
										}
									});
								}
								setUpdateConfigurations($timeout);
							},
							cancel: '.disabled'
						};
						var name = $scope.name;
						var windowPrint;
						setFilterFunctions();
						$scope.filterService = leanFilterService;
						$scope.filters = leanFilterService.masterFilterList;
						$scope.rangeFilters = leanFilterService.masterRangeFilterList;
						$scope.stringFilters = leanFilterService.masterStringFilterList;
						$scope.singleSelectFilters = leanFilterService.masterSingleSelectFilterList;
						$scope.reportIsAuthorized = true;

						var configReadyListener = $rootScope.$on('reportConfigReady', dashboardFilterInitializationService.finishInitialLoad);

						// Filter functions
						function setFilterFunctions() {
							$scope.filterFunctions = tableFilterFunctionsService;

							// Filter related functions
							$scope.filterFunctions.applySelection = function ($event, filterId) {
								$scope.noResultsText = 'We couldn\'t find any results that match this filter.';
								$scope.noResultsSuggestion = 'It\'s probably too specific, try removing some of the filters.';
								$scope.clearFiltersText = 'Or, clear the filters and start over.';
								$scope.filtered = true;
								tableFilterFunctionsService.applySelectionInner($event, filtersChanged, filterId, true, undefined, globalReportName);
							};
							$scope.filterFunctions.removeFilter = function (filter) {
								$scope.noResultsText = 'We couldn\'t find any results that match this filter.';
								$scope.noResultsSuggestion = 'It\'s probably too specific, try removing some of the filters.';
								$scope.clearFiltersText = 'Or, clear the filters and start over.';
								$scope.filtered = true;
								tableFilterFunctionsService.removeFilterInner(filter, filtersChanged, true, undefined, globalReportName);
							};
							$scope.filterFunctions.clearAllFilters = function () {
								$scope.noResultsText = 'We couldn\'t find any results that match this filter.';
								$scope.noResultsSuggestion = 'It\'s probably too specific, try removing some of the filters.';
								$scope.clearFiltersText = 'Or, clear the filters and start over.';
								$scope.filtered = true;
								tableFilterFunctionsService.clearAllFiltersInner(filtersChanged, true, undefined, globalReportName);
							};
						}

						function filtersChanged(start, loadFilters, waitForFilters, isFilterChanged, filterId) {
							dashboardFilterInitializationService.updateFilters(waitForFilters, filterId);
						}

						// Print Setup
						function detectIE() {
							var ua = window.navigator.userAgent;

							var msie = ua.indexOf('MSIE ');
							if (msie > 0) {
								// IE 10 or older => return version number
								return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
							}

							var trident = ua.indexOf('Trident/');
							if (trident > 0) {
								// IE 11 => return version number
								var rv = ua.indexOf('rv:');
								return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
							}

							var edge = ua.indexOf('Edge/');
							if (edge > 0) {
								// Edge (IE 12+) => return version number
								return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
							}

							// other browser
							return false;
						}

						if (window.matchMedia) {
							windowPrint = window.matchMedia('print');
						}

						var beforePrint = function () {
							var charts = chartService.getChartsForPrint();

							_.forEach(charts, function (value, key) {
								value.flush();
							});
						};

						var beforePrintListener = function (mql) {
							if (mql.matches) {
								beforePrint();
							}
						};

						if (windowPrint) {
							windowPrint.addListener(beforePrintListener);
						}

						if (detectIE()) {
							window.onbeforeprint = beforePrint;
						}

						// Watching for changes on adfModel
						$scope.$watch('adfModel', function (newVal, oldVal) {
							if (newVal != null) {
								setMaxWidthOfFilterDiv();
								model = $scope.adfModel;
								if (model) {
									var state = storeService.getState();
									$scope.sortableOptions.disabled = state.reportSettings.readOnly;
									$scope.model = model;
									$scope.reportIsAuthorized = state.reportSettings.authorizationLevel !== 'NONE';
									$scope.trendlineText = 'Show Trendline';
									var state = storeService.getState();
									if (state.reportSettings.config.showTrendline) {
										$scope.trendlineText = 'Hide Trendline';
									}
									$scope.isPerformanceDashboard = (
										$scope.model.baseReportName === performanceDashboardDescription);
									if ($scope.model.baseReportName === 'X-matrix') {
										$scope.isXMatrix = true;
									}
									if (!checkedForSlideshow) {
										checkedForSlideshow = true;
										startSlideshowOnLoad();
									}
									if (needPerformanceDashboardReload && $scope.isPerformanceDashboard) {
										needPerformanceDashboardReload = false;
										$rootScope.$broadcast('performanceDashboardFilterChanged');
									}
								} else {
									$log.error('could not find or create model');
								}
								$timeout(function () {
									// dashboard_global_functions
									syncColHeights();
								}, 0);
							}
						}, true);



						$scope.loadXMatrix = function (filterType, filter) {
							jQuery('.matrix-name').html(filter);
							$translate(filter).then(function(tt) {
								jQuery('.matrix-name').html(tt);
							});
							$rootScope.$emit('xMatrixFilterChanged');
						};

						// edit mode
						$scope.editMode = true;
						$scope.editClass = '';

						$scope.toggleSelection = function (e) {
							if (e) {
								e.stopPropagation();
							}
							$scope.showDropDown = !$scope.showDropDown;
							if ($scope.showDropDown) {
								if ($scope.showViewDropDown) {
									$scope.toggleViewSelection(e);
								}
								$window.onclick = function (e) {
									var target = jQuery(e.target);
									if (target.length === 0) {
										return;
									}
									if (!target.hasClass('showDropDown')) {
										$scope.toggleSelection();
									}
								};
							} else if (!e) {
								$window.onclick = null;
								$scope.$apply();
							}
						};

						$scope.toggleTrendline = function () {
							var cur = storeService.getState().reportSettings.config.showTrendline;
							$scope.trendlineText = !cur ? 'Hide Trendline' : 'Show Trendline';
							storeService.dispatch({
								type: storeService.actions.CONFIG_SET_TRENDLINE,
								payload: {
									showTrendline: !cur
								},
								meta: {
									reportName: undefined,
									reportSettingsId: globalReportName
								}
							});
							$rootScope.$broadcast('performanceDashboardFilterChanged');
						};

						$scope.readOnlyWidgets = function () {
							if ($scope.model) {
								if ($scope.model.baseReportName && (
									$scope.model.baseReportName === 'Control tower' ||
										$scope.model.baseReportName === 'POs to action: next 12 months' ||
										$scope.model.baseReportName === 'Late delivery causes' ||
										$scope.model.baseReportName === 'X-matrix' ||
										$scope.model.baseReportName === performanceDashboardDescription)) {
									return true;
								} else {
									return false;
								}
							} else {
								return false;
							}
						};

						$scope.toggleViewSelection = function (e) {
							if (e) {
								e.stopPropagation();
							}
							$scope.showViewDropDown = !$scope.showViewDropDown;
							if ($scope.showViewDropDown) {
								if ($scope.showDropDown) {
									$scope.toggleSelection(e);
								}
								$window.onclick = function (e) {
									var target = jQuery(e.target);
									if (target.length && !target.hasClass('showViewDropDown')) {
										$scope.toggleViewSelection();
									}
								};
							} else if (!e) {
								$window.onclick = null;
								$scope.$apply();
							}
						};

						$scope.startSlideshow = function (crossDashboard) {
							var refreshEvent = null;
							if (!slideshowControls.initialLoad && crossDashboard) {
								slideshowControls.initialLoad = true;
								slideshowControls.transitionTime = 10000;
								refreshEvent = $timeout(function () {
									$location.search({
										'slideshow': 'true',
										'transitionTime': slideshowControls.transitionTime
									});
									if (!$rootScope.connectionLost) {
										dashboardService.reloadPage();
									}
								}, 10 * 60 * 1000);
							} else if (!slideshowControls.initialLoad) {
								slideshowControls.initialLoad = true;
								refreshEvent = $timeout(function () {
									$location.search({
										'slideshowSingle': 'true',
										'transitionTime': slideshowControls.transitionTime
									});
									if (!$rootScope.connectionLost) {
										dashboardService.reloadPage();
									}
								}, 20 * 60 * 1000);
							}
							var slideshowScope = $scope.$new();
							slideshowScope.widgets = flattenWidgetModel();
							var extraWids = nonSlideshowWidgetCount();
							var stopInterval;
							var index = 0;
							slideshowScope.paused = slideshowControls.paused;
							slideshowScope.display = {};
							slideshowScope.display.timerDisplay = slideshowControls.transitionTime / 1000;
							var timeoutPromise = null;
							slideshowScope.movedMouse = function () {
								if (timeoutPromise) {
									$timeout.cancel(timeoutPromise);
								}
								slideshowScope.display.displayControls = true;
								timeoutPromise = $timeout(function () {
									slideshowScope.display.displayControls = false;
								}, 1500);
							};

							slideshowScope.nextSlide = function () {
								slideshowScope.widgets[index].visible = false;
								index++;
								if (index >= slideshowScope.widgets.length) {
									index = 0;
									var navList = storeService.getState().myViews.views.dashboards;
									var slideshowDBs = [];
									var i;
									for (i = 0; i < navList.length; i++) {
										if (navList[i].baseReportName !== 'buyer-performance' 
											&& navList[i].baseReportName !== 'site-performance'
											&& navList[i].baseReportName !== 'item-group-performance'
											&& navList[i].baseReportName !== 'Data Health Dashboard'
											&& navList[i].baseReportName !== 'Superset') {
											slideshowDBs.push(navList[i]);
										}
									}
									if (slideshowDBs && slideshowDBs.length > 1 && crossDashboard) {
										slideshowScope.closeDialog();
										var selectedPath = $location.path().substring(11);
										if (selectedPath.indexOf('?') > 0) {
											selectedPath = selectedPath.substring(0, selectedPath.indexOf('?'));
										}
										var nextPathIndex = 0;
										for (i = 0; i < navList.length; i++) {
											if (slideshowDBs[i].id.toString() === selectedPath) {
												nextPathIndex = (i + 1) % slideshowDBs.length;
												break;
											}
										}
										slideshowControls.startAtLast = false;
										$location.path('/dashboard/' + slideshowDBs[nextPathIndex].id)
											.search({
												'slideshow': 'true'
											});
									}
								}
								slideshowScope.widgets[index].visible = true;
							};

							slideshowScope.previousSlide = function () {
								slideshowScope.widgets[index].visible = false;
								index--;
								if (index < 0) {
									index = slideshowScope.widgets.length - 1;
									var navList = storeService.getState().myViews.views.dashboards;
									var slideshowDBs = [];
									var i;
									for (i = 0; i < navList.length; i++) {
										if (navList[i].baseReportName !== 'buyer-performance'
											&& navList[i].baseReportName !== 'site-performance'
											&& navList[i].baseReportName !== 'item-group-performance'
											&& navList[i].baseReportName !== 'Data Health Dashboard'
											&& navList[i].baseReportName !== 'Superset') {
											slideshowDBs.push(navList[i]);
										}
									}
									if (slideshowDBs && slideshowDBs.length > 1 && crossDashboard) {
										slideshowScope.closeDialog();
										var selectedPath = $location.path().substring(11);
										if (selectedPath.indexOf('?') > 0) {
											selectedPath = selectedPath.substring(0, selectedPath.indexOf('?'));
										}
										var nextPathIndex = 0;
										for (i = 0; i < slideshowDBs.length; i++) {
											if (navList[i].id.toString() === selectedPath) {
												nextPathIndex = i - 1 < 0 ? slideshowDBs.length - 1 : i - 1;
												break;
											}
										}
										slideshowControls.startAtLast = true;
										$location.path('/dashboard/' + slideshowDBs[nextPathIndex].id)
											.search({
												'slideshow': 'true'
											});
									}
								}
								slideshowScope.widgets[index].visible = true;
							};

							slideshowScope.pause = function () {
								if (stopInterval) {
									slideshowScope.paused = true;
									slideshowControls.paused = true;
									$interval.cancel(stopInterval);
								}
							};

							slideshowScope.play = function () {
								slideshowScope.paused = false;
								slideshowControls.paused = false;
								stopInterval = $interval(function () {
									if (!$rootScope.connectionLost) {
										slideshowScope.nextSlide();
									} else {
										slideshowScope.pause();
									}
								}, slideshowControls.transitionTime);
							};

							slideshowScope.changeInterval = function (value) {
								var wasPaused = slideshowControls.paused;
								if ((value < 0 && slideshowScope.display.timerDisplay === 3) ||
									(value > 0 && slideshowScope.display.timerDisplay === 60)) {
									return;
								}
								slideshowScope.pause();
								slideshowScope.display.timerDisplay = slideshowScope.display.timerDisplay + value;
								if (slideshowScope.display.timerDisplay) {
									slideshowControls.transitionTime = slideshowScope.display.timerDisplay * 1000;
								}
								if (!wasPaused) {
									slideshowScope.play();
								}
							};

							if (slideshowScope.widgets && slideshowScope.widgets.length > 0) {
								slideshowControls.noWidgets = false;
								slideshowControls.seenWidget = true;
								if (slideshowControls.startAtLast) {
									index = slideshowScope.widgets.length - 1;
								}
								slideshowScope.widgets[index].visible = true;
								$rootScope.slideshowView = true;
								if (!slideshowScope.paused) {
									slideshowScope.play();
								}
								var instance = $uibModal.open({
									scope: slideshowScope,
									templateUrl: adfTemplatePath + 'widget-slideshow.html',
									windowTemplateUrl: adfTemplatePath + 'widget-slideshow-template.html'
								});

								//callback to call the closedialog function on esc or click away close
								instance.result.then(function () {
									//do nothing on success
								}, function () {
									slideshowControls.noWidgets = false;
									slideshowControls.seenWidget = false;
									slideshowControls.startingPath = '';
									slideshowControls.initialLoad = false;
									$timeout.cancel(refreshEvent);
									slideshowScope.closeDialog();
								});
							} else if (extraWids > 0) {
								var navList = storeService.getState().myViews.views.dashboards;
								var selectedPath = $location.path().substring(11);
								if (navList && navList.length > 1 && crossDashboard &&
									!(selectedPath === slideshowControls.startingPath &&
										slideshowControls.noWidgets && !slideshowControls.seenWidget)) {
									slideshowControls.noWidgets = true;
									if (selectedPath.indexOf('?') > 0) {
										selectedPath = selectedPath.substring(0, selectedPath.indexOf('?'));
									}
									var nextPathIndex = 0;
									for (var i = 0; i < navList.length; i++) {
										if (navList[i].id.toString() === selectedPath) {
											nextPathIndex = (i + 1) % navList.length;
											break;
										}
									}
									slideshowControls.startAtLast = false;
									$location.path('/dashboard/' + navList[nextPathIndex].id)
										.search({
											'slideshow': 'true'
										});
								} else if (selectedPath === slideshowControls.startingPath && slideshowControls.noWidgets) {
									showErrorToast('There were no widgets eligible for slideshow mode');
									slideshowControls.startingPath = '';
									slideshowControls.noWidgets = false;
									slideshowControls.seenWidget = false;
									slideshowControls.initialLoad = false;
									$timeout.cancel(refreshEvent);
									//showErrorToast("There were no widgets eligible for slideshow mode.");
								} else if (!crossDashboard) {
									showErrorToast('There were no widgets eligible for slideshow mode');
									slideshowControls.startingPath = '';
									slideshowControls.noWidgets = false;
									slideshowControls.seenWidget = false;
									slideshowControls.initialLoad = false;
									$timeout.cancel(refreshEvent);
								}
							} else {
								$timeout(function () {
									$scope.startSlideshow(crossDashboard);
								}, 10);
							}

							slideshowScope.closeDialog = function () {
								instance.close();
								$timeout(function () {
									$rootScope.slideshowView = false;
									$rootScope.$broadcast('slideshowViewChanged');
								}, 0);
								$interval.cancel(stopInterval);
								slideshowScope.$destroy();

							};
						};

						function nonSlideshowWidgetCount() {
							var result = 0;
							for (var i = 0; i < 3; i++) {
								var col = model.config['column' + i];
								if (col) {
									col.forEach(function(widget) {
										var originalWidget = widget.type ? dashboard.widgets[widget.type] : dashboard.widgets[widget.name];
										if (!originalWidget.slideshowView) {
											result++;
										}
									});
								}
							}
							return result;
						}

						function showErrorToast(message) {
							$scope.errorMessage = message;
							$timeout(function () {
								$scope.errorMessage = '';
							}, 3000);
						}

						$scope.clearToast = function () {
							$scope.errorMessage = '';
						};

						function flattenWidgetModel() {
							var result = [];
							for (var i = 0; i < 3; i++) {
								var col = model.config['column' + i];
								if (col) {
									col.forEach(function(widget) {
										var wid = jQuery.extend({}, widget);
										wid.visible = false;
										var originalWidget = wid.type ? dashboard.widgets[wid.type] : dashboard.widgets[wid.name];
										if (originalWidget.slideshowView) {
											result.push(wid);
										}
									});
								}
							}
							return result;
						}


						$scope.toggleFilterListSelection = function (e) {
							if (e) {
								e.stopPropagation();
							}
							$scope.showFilterListDropDown = !$scope.showFilterListDropDown;
							if ($scope.showFilterListDropDown) {
								$window.onclick = function (e) {
									var target = jQuery(e.target);
									if (target.length === 0) {
										return;
									}
									if (!target.hasClass('showFilterListDropDown')) {
										$scope.toggleFilterListSelection();
									}
								};
							} else if (!e) {
								$window.onclick = null;
								$scope.$apply();
							}
						};

						$scope.toggleEditMode = function () {
							$scope.editMode = !$scope.editMode;
							if ($scope.editMode) {
								$scope.modelCopy = angular.copy($scope.adfModel, {});
							}

							if (!$scope.editMode) {
								$rootScope.$broadcast('adfDashboardChanged', name, model);
							}
						};

						$scope.cancelEditMode = function () {
							$scope.editMode = false;
							$scope.modelCopy = angular.copy($scope.modelCopy, $scope.adfModel);
						};

						// edit dashboard settings
						$scope.addNewDashboardDialog = function () {
							var addDashboardScope = $scope.$new();
							dashboard.header = 'Create New Dashboard';
							addDashboardScope.title = 'Title';
							dashboard.title = '';
							dashboard.description = '';
							$scope.dashboard = dashboard;
							$scope.isEdit = false;
							$http.get(String.format(URLS.dashboards, globalConfig.customer.id)).then(
								function (response) {
									//Creating empty option
									var emptyOption = {
										id: -1,
										name: 'Choose a dashboard',
										description: ''
									};
									$scope.dashboards = dashboardService.moveEmptyToEndOfList(response.data);
									if ($scope.dashboards.length > 0) {
										$scope.dashboards.unshift(emptyOption);
										$scope.dashboard.startwith = $scope.dashboards[0];
										var isCtbSingleLevelEnabled = userConfigUtilsService.getClearToBuildSingleLevelEnabledForUser();
										var isCtbMultiLevelEnabled = userConfigUtilsService.getClearToBuildMultiLevelEnabledForUser();
										var plannerPerformanceSingleLevelIdx = -1;
										var plannerPerformanceMultiLevelIdx = -1;
										for(var i=0; i < $scope.dashboards.length; i++){
											if($scope.dashboards[i].name === 'Planner Performance (Single Level)'){
												plannerPerformanceSingleLevelIdx = i;
											}
											if($scope.dashboards[i].name === 'Planner Performance (Multi Level)'){
												plannerPerformanceMultiLevelIdx = i;
											}
										}
										if(!isCtbSingleLevelEnabled){
											$scope.dashboards.splice(plannerPerformanceSingleLevelIdx, 1);
										}
										if(!isCtbMultiLevelEnabled){
											$scope.dashboards.splice(plannerPerformanceMultiLevelIdx, 1);
										}
									}
								},
								function (error) {}
							);
							var instance = $uibModal.open({
								scope: addDashboardScope,
								templateUrl: adfTemplatePath + 'dashboard-edit.html'
							});
							focus('dashboardName');
							addDashboardScope.closeDialog = function () {
								instance.close();
								addDashboardScope.$destroy();
							};
							addDashboardScope.startWithChange = function () {
								if ($scope.dashboard.startwith.id !== -1) {
									$scope.dashboard.title = $scope.dashboard.startwith.name;
									$translate( $scope.dashboard.startwith.name).then(function(tt) {
										$scope.dashboard.title = tt;
									});
									$scope.dashboard.startWithError = false;
								} else {
									$scope.dashboard.startWithError = true;
									$scope.dashboard.title = '';
								}
							};
							addDashboardScope.addDashboard = function () {
								var dd = $scope.dashboard;
								if (dd.startwith.id === -1) {
									dd.startWithError = true;
									return false;
								}
								var startwith = {};
								if (dd.startwith) {
									startwith = dd.startwith;
								}

								var isXMatrix = startwith && startwith.config.includes('"type":"xMatrix"');
								var defaultFactoryFilter = !isXMatrix ? leanFilterService.leanDnaAllSelected : globalConfig.factory.id;
								var filters =[{id: 'factory', values: [defaultFactoryFilter]}];
								if(startwith.name === 'Planner Performance (Single Level)' || startwith.name === 'Planner Performance (Multi Level)'){
									filters.push(
										{
											id: 'ctbTimePeriod',
											values: ['ctbWindow'],
											comparator: leanFilterService.comparatorsMap.ctbWindow
										}
									);
								}

								var newDashboard = {
									reportName: dd.title,
									baseReportName: startwith ? startwith.name : '',
									filters: filters,
									columns: [],
									recordsPerPage: 0,
									viewType: 'dashboards',
									type:  'customer',
									userModified: true,
									search: '',
									config: startwith ? JSON.parse(startwith.config) : {}
								};
								dashboardCreationService.createDashboard(newDashboard, createDashboardCallback);

							};
							addDashboardScope.onSave = function () {
								if ($scope.dashboard.title.trim() !== '' &&
									$scope.dashboard.startwith !== '' &&
									$scope.dashboard.startwith.id !== -1) {
									return true;
								}
								return false;
							};

							function createDashboardCallback(response, newDashboard) {
								if (response && response.status >= 400) {
									$timeout(function() {
										addDashboardScope.hasError = true;
										addDashboardScope.errorMessage = response.status === 409 ? '* Dashboard name already exists' : 'Unexpected server error';
									});
									return;
								}
								pendo.track('addDashboard', {
									name: newDashboard.reportName,
									parentName: newDashboard.baseReportName,
									structure: newDashboard.config.layout
								});
								var state = navigationService.getStateForDashboard({id: response.data.ndx, baseReportName: newDashboard.baseReportName});
								$state.go(state.sref, state.params);
								instance.close();
								addDashboardScope.$destroy();
							}
						};

						$scope.$on('addNewDashboardDialog', $scope.addNewDashboardDialog);

						$scope.printDashboard = function () {
							chartService.clearChartsForPrint();

							var widgets = flattenWidgetModel();
							var printWidgetScope = $scope.$new();
							printWidgetScope.widgets = widgets;
							printWidgetScope.print = function () {
								window.print();
							};

							var instance = $uibModal.open({
								scope: printWidgetScope,
								templateUrl: '/application/f/dashboard/widgets/widget-print.html',
								windowTemplateUrl: '/application/f/dashboard/widgets/widget-print-template.html'
							});

							$rootScope.printView = true;
							$rootScope.$broadcast('printViewChanged');
							setupPrint(true);

							// Listener for Print Setup
							var afterPrint = function () {
								instance.close();
								setupPrint(false);
								printWidgetScope.$destroy();
							};

							if (window.matchMedia) {
								var mediaQueryList = window.matchMedia('print');
								mediaQueryList.addListener(function (mql) {
									if (mql.matches) {} else {
										afterPrint();
									}
								});
							}

							window.onafterprint = afterPrint;

							instance.result.then(function () {
								instance.close();
								setupPrint(false);
								printWidgetScope.$destroy();
							}, function () {
								instance.close();
								setupPrint(false);
								printWidgetScope.$destroy();
							});
						};

						/**
						 * Tidies up page for printing
						 *
						 * @param {*} status - True for opening print, False for closing print
						 */
						function setupPrint(status) {
							if (status) {
								// Hide background for printing
								document.getElementById('topView').style.display = 'none';
								document.getElementById('sideView').style.display = 'none';
								document.getElementById('mainView').style.display = 'none';
								jQuery('.metric-settings').css('display', 'none');
								// Hide Widget Controls
								document.getElementById('widgetControl').style.display = 'none';
							} else {
								// Show background
								document.getElementById('topView').style.display = 'block';
								document.getElementById('sideView').style.display = 'block';
								document.getElementById('mainView').style.display = 'block';
								jQuery('.metric-settings').css('display', 'block');
								// Show Widget Controls
								document.getElementById('widgetControl').style.display = 'block';

								$timeout(function () {
									$rootScope.printView = false;
									$rootScope.$broadcast('metricFilterChanged');
									$rootScope.$broadcast('printViewChanged');
								}, 0);
							}
						}

						$scope.changeStructure = function (name, structure) {
							var originalNumberOfColumns = model.config.layout.length - 7;
							var newNumberOfColumns = name.length - 7;
							if (originalNumberOfColumns > newNumberOfColumns) {
								storeService.dispatch({
									type: storeService.actions.CONFIG_WIDGET_MOVE_ALL,
									payload: {
										sourceColumn: 'column2',
										destinationColumn: 'column1'
									},
									meta: {
										reportName: undefined,
										reportSettingsId: globalReportName
									}
								});
								if (newNumberOfColumns === 1) {
									storeService.dispatch({
										type: storeService.actions.CONFIG_WIDGET_MOVE_ALL,
										payload: {
											sourceColumn: 'column1',
											destinationColumn: 'column0'
										},
										meta: {
											reportName: undefined,
											reportSettingsId: globalReportName
										}
									});
								}
							}
							storeService.dispatch({
								type: storeService.actions.CONFIG_SET_LAYOUT,
								payload: {
									layout: name
								},
								meta: {
									reportName: undefined,
									reportSettingsId: globalReportName
								}
							});
							$scope.selectedIndex = name;
							setUpdateConfigurations($timeout);
						};

						$scope.editLayoutDialog = function () {
							var editLayoutDialog = $scope.$new();
							//this structure has other widgets in it (sometimes)!
							editLayoutDialog.structures = dashboard.structures;
							$scope.selectedIndex = model.config.layout;
							var instance = $uibModal.open({
								scope: editLayoutDialog,
								templateUrl: adfTemplatePath + 'dashboard-layout.html'
							});

							$scope.getClass = function (ind) {
								if (ind === $scope.selectedIndex) {
									return 'active';
								} else {
									return '';
								}
							};
							editLayoutDialog.closeDialog = function () {
								instance.close();
								editLayoutDialog.$destroy();
							};
						};

						$scope.$on('add-widget-to-dashboard', function(events, widgetType) {
							addWidget(widgetType);
						});

						function addWidget(widgetType) {
							if (checkForOverLimit()){
								$rootScope.$emit('toast', {
									'message': 'Total widget limit exceeded for dashboard',
									'success': false,
									'time': 5000
								});
								return;
							}
							var widget = _.cloneDeep(dashboard.widgets[widgetType]);
							widget.config = widget.config ? widget.config : {};
							widget.config.title = widget.name;
							widget.config.type = widget.type;
							widget.title = widget.name;
							if (WEEKLY_LOG_ITEM_FIELDS[widget.type]) {
								weeklyLogItemService.addField(WEEKLY_LOG_ITEM_FIELDS[widgetType]);
							}
							dashboardFilterInitializationService.addWidgetFilters(widget.type);
							storeService.dispatch({
								type: storeService.actions.CONFIG_WIDGET_ADD_ONE,
								payload: {
									column: 'column0',
									position: 0,
									widget: {
										name: widgetType,
										config: widget.config
									}
								},
								meta: {
									reportName: undefined,
									reportSettingsId: globalReportName
								}
							});
							widget.widgetIndex = $scope.widgetIndex++;
							widget.isNew = true;
							$scope.model.config.column0.unshift(widget);
							setUpdateConfigurations($timeout);
						}

						function checkForOverLimit() {
							var count = $scope.model.config.column0.length
								+ $scope.model.config.column1.length
								+ $scope.model.config.column2.length;
							return count >= 50;
						}

						// add widget dialog
						$scope.addWidgetDialog = function () {
							var addScope = $scope.$new();
							addScope.search = {
								input: ''
							};
							//FIXME - Widget filter of Control Tower, should we use a variable check
							// rather than a string match?
							var widgets = getWidgets();
							addScope.widgets = _.cloneDeep(widgets);
							
							var opts = {
								scope: addScope,
								templateUrl: adfTemplatePath + 'widget-add.html'
							};
							if ($scope.staticBackdrop) {
								opts.backdrop = 'static';
							}
							addScope.selectedCategory = 0;
							var instance = $uibModal.open(opts);
							addScope.setSelected = function (selected) {
								addScope.selectedCategory = selected;
							};
							addScope.isSelected = function (index, selectedCategory) {
								return (selectedCategory === index);
							};
							addScope.addWidget = function (widgetType) {
								addWidget(widgetType);
							};
							addScope.closeDialog = function () {
								instance.close();
								addScope.$destroy();
								$scope.staticBackdrop = false;
							};
							addScope.filterWidgets = function ($searchText) {
								var filteredWidgets = _.cloneDeep(widgets);
								if ($searchText && $searchText.length >= 3) {
									angular.forEach(filteredWidgets, function (widegetsByType) {
										var widgets = _.filter(widegetsByType.widgets, function ($widget) {
											return $translate.instant($widget.name).toLowerCase().indexOf($searchText.toLowerCase()) !== -1 ||
												$translate.instant($widget.description).toLowerCase().indexOf($searchText.toLowerCase()) !== -1;
										});
										widegetsByType.widgets = widgets;
									});
								}
								addScope.widgets = filteredWidgets;
							};
							addScope.clearText = function() {
								addScope.filterWidgets('');
								addScope.search.input = '';
							};
						};

						$scope.singleDashboardSlideshow = function () {
							var selectedPath = $location.path().substring(11);
							if (selectedPath.indexOf('?') > 0) {
								selectedPath = selectedPath.substring(0, selectedPath.indexOf('?'));
							}
							slideshowControls.startingPath = selectedPath;
							slideshowControls.noWidgets = false;
							slideshowControls.seenWidget = false;
							$scope.startSlideshow();
						};

						$scope.$on('performanceDashboardFilterChanged', function () {
							if (typeof $scope.model === 'undefined'
								|| typeof $scope.model.baseReportName === 'undefined') {
								// Model hasn't initialized yet, try again
								needPerformanceDashboardReload = true;
								return;
							}
							if (typeof $scope.model !== 'undefined' &&
								typeof $scope.model.baseReportName !== 'undefined' &&
								$scope.model.baseReportName === performanceDashboardDescription) {
								$rootScope.title = 'LeanDNA Dashboard - Performance metrics';
								reloadPerformanceDashboard();
							} else {
								dashboardFilterInitializationService.setPerformanceDashboard(false);
							}
						});

						function reloadPerformanceDashboard() {
							if (dashboardFilterInitializationService.isPerformanceDashboard()) {
								var promiseList = [];
								var metricList = [];
								var errorMessage = '';
								var curDashboardId = storeService.getState().reportSettings.reportSettingsId;
								$scope.metricDropdownList = [];
								storeService.dispatch({
									type: storeService.actions.CONFIG_SET_LAYOUT,
									payload: {
										layout: 'layout-aa'
									},
									meta: {
										reportName: undefined,
										reportSettingsId: globalReportName,
										doNotSave: storeService.getState().reportSettings.readOnly
									}
								});
								storeService.dispatch({
									type: storeService.actions.CONFIG_WIDGET_DELETE_ALL_COLUMNS,
									meta: {
										reportName: undefined,
										reportSettingsId: globalReportName,
										doNotSave: storeService.getState().reportSettings.readOnly
									}
								});

								promiseList.push(performanceDashboardService.getMetricList());
								promiseList.push(performanceDashboardService.getMetrics());

								var organizeWidgets = function () {
									var colOne = [];
									var colTwo = [];
									var i, widget;
									for (i = 0; i < $scope.performanceDashboardWidgets.length; i++) {
										if (i % 2) {
											colTwo.push($scope.performanceDashboardWidgets[i]);
										} else {
											colOne.push($scope.performanceDashboardWidgets[i]);
										}
									}
									storeService.dispatch({
										type: storeService.actions.CONFIG_WIDGET_SET_COLUMN,
										payload: {
											column: 'column0',
											widgets: colOne.map(function(wid) {
												return {
													name: 'metric',
													config: wid.config
												};
											})
										},
										meta: {
											reportName: undefined,
											reportSettingsId: globalReportName,
											doNotSave: storeService.getState().reportSettings.readOnly
										}
									});
									storeService.dispatch({
										type: storeService.actions.CONFIG_WIDGET_SET_COLUMN,
										payload: {
											column: 'column1',
											widgets: colTwo.map(function(wid) {
												return {
													name: 'metric',
													config: wid.config
												};
											})
										},
										meta: {
											reportName: undefined,
											reportSettingsId: globalReportName,
											doNotSave: storeService.getState().reportSettings.readOnly
										}
									});
									colOne.map(function(widget) {
										widget.widgetIndex = $scope.widgetIndex++;
										return widget;
									});
									colTwo.map(function(widget) {
										widget.widgetIndex = $scope.widgetIndex++;
										return widget;
									});
									$scope.model.config.column0.length = 0;
									$scope.model.config.column1.length = 0;
									$scope.model.config.column0.push.apply($scope.model.config.column0, colOne);
									$scope.model.config.column1.push.apply($scope.model.config.column1, colTwo);
									setUpdateConfigurations($timeout);
								};

								var addAllWidgets = function () {
									$q.all(promiseList).then(function(responses) {
										handleMetricListPromise(responses[0]);
										handleMetricPromise(responses[1]);
										if ((errorMessage && errorMessage.length) || curDashboardId !== globalReportName) {
											return;
										}

										$scope.performanceDashboardWidgets = [];
										$scope.metricNdxList = [];
										angular.forEach(metricList, function (metric) {
											var met = {};
											met.name = 'metric';
											met.config = {
												'title': 'Metrics',
												'type': 'metric',
												'metricNdx': metric.ndx
											};
											met.slideshowView = true;
											$scope.performanceDashboardWidgets.push(met);
										});
										organizeWidgets();
									});
								};

								var handleMetricPromise = function(data) {
									$scope.metricDropdownList = data;
									for (var i = $scope.metricDropdownList.length - 1; i >= 0; i--) {
										// strip() is in dashboard_global_functions
										$scope.metricDropdownList[i].name = strip($scope.metricDropdownList[i].name);
									}
								};

								var handleMetricListPromise = function(data) {
									metricList = data;
									if (!metricList || !metricList.length) {
										$scope.showNoResults = true;
									} else if (metricList.length > 25) {
										$scope.showNoResults = false;
										var length = metricList.length;
										metricList = metricList.slice(0, 25);
										showErrorToast('Showing 25 of ' + length + ' metrics. Please refine your filters.');
									} else {
										$scope.showNoResults = false;
									}
								};

								addAllWidgets();
							}
						}

						//End Filters
						function startSlideshowOnLoad() {
							if ($location.search() && $location.search().slideshow) {
								if (!slideshowControls.startingPath) {
									if ($location.search().transitionTime) {
										slideshowControls.transitionTime = $location.search().transitionTime;
									}
									var selectedPath = $location.path().substring(11);
									if (selectedPath.indexOf('?') > 0) {
										selectedPath = selectedPath.substring(0, selectedPath.indexOf('?'));
									}
									slideshowControls.startingPath = selectedPath;
								}
								$timeout(function() { $scope.startSlideshow(true);});
							} else if ($location.search() && $location.search().slideshowSingle) {
								if ($location.search().transitionTime) {
									slideshowControls.transitionTime = $location.search().transitionTime;
								}
								$scope.singleDashboardSlideshow();
							}
						}

						$scope.$on('$destroy', function () {
							if (windowPrint) {
								windowPrint.removeListener(beforePrintListener);
							}
							chartService.clearChartsForPrint();
							jQuery(window).off('resize');
							configReadyListener();
						});
					},
					link: function ($scope, $element, $attr) {
						// pass attributes to scope
						$scope.name = $attr.name;
						$scope.structure = $attr.structure;
					},
					templateUrl: adfTemplatePath + 'dashboard.html'
				};
			}
		]);
})();
